import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExternalLink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.54545 4C4.69193 4 4 4.69193 4 5.54545V19.4545C4 20.3081 4.69193 21 5.54545 21H19.4545C20.3081 21 21 20.3081 21 19.4545V14.0455C21 13.6187 20.654 13.2727 20.2273 13.2727C19.8006 13.2727 19.4545 13.6187 19.4545 14.0455V19.4545H5.54545V5.54545H10.9545C11.3813 5.54545 11.7273 5.19949 11.7273 4.77273C11.7273 4.34597 11.3813 4 10.9545 4H5.54545ZM20.7737 4.22633C20.8478 4.30042 20.9037 4.38581 20.9414 4.47694C20.9785 4.5667 20.9994 4.66501 21 4.76809V4.77273V9.40909C21 9.83585 20.654 10.1818 20.2273 10.1818C19.8006 10.1818 19.4545 9.83585 19.4545 9.40909V6.63826L11.5009 14.5919C11.1992 14.8936 10.7099 14.8936 10.4082 14.5919C10.1064 14.2901 10.1064 13.8008 10.4082 13.4991L18.3618 5.54545H15.5909C15.1641 5.54545 14.8182 5.19949 14.8182 4.77273C14.8182 4.34597 15.1641 4 15.5909 4H20.2271C20.3319 4 20.4319 4.02085 20.5231 4.05863C20.6143 4.09634 20.6996 4.15224 20.7737 4.22633Z",
		fill: "#8C8C8C"
	})]
});
const ForwardRef = forwardRef(SvgExternalLink);
export default ForwardRef;
